var _style, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHair4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Lager_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 218.8 184.5",
    style: {
      enableBackground: "new 0 0 218.8 184.5"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:url(#SVGID_1_);}\n\t.st1{opacity:0.9;fill:#D177B8;}\n\t.st2{fill:#FFD4E0;}\n")), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 109.3876,
    y1: 184.479,
    x2: 109.3876,
    y2: 11.8169
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#471F4B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#310A39"
    }
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M218.7,127.4c-0.1,1.1-0.5,2.4-1.1,3.7c-1.1,2.6-3,5.6-5.2,8.7c-6.3,9-15.3,18.3-16,19c0.1-0.3,1.3-3.3,1-5.3 l-4.8,5.4l0,0.1c-3.8,4.3-8.7,9.7-9.4,9.9c-1.2,0.5-12.6,5-12.6,5s-5.2,6.1-10.7,10.5h-3.6c0,0,21.6-32.8,20.7-59.8 c-0.9-27-8.7-64.7-13.3-76.3c0.2,0.7,1.7,6.4,1.9,13.8l-25.7-1.8c0,0,2.6-19.7-2.8-27.5c0,0,2.6,17.5,1.2,27.8L119,58.2 c0,0,0.3-27.4-6.5-36.1l-5.3,1.4c0,0-9.7,14.5-8.8,38.2l-12.2,1.7c0,0-0.9-17.2,5.8-32.1c0,0,0,0,0,0c0,0.1-0.1,0.1-0.1,0.2 c-0.4,0.7-1.9,3.1-3.6,6.6c0,0.1-0.1,0.1-0.1,0.2c-3.1,6.5-7,16.6-6.8,26.7l-18.2,0l-0.9-11.1l-1.5,11.1l-5.6,0.8 c0,0-3,29.1-7.1,50.2c-4,20.8,6.1,60.6,15.7,68.1c0.2,0.2,0.4,0.3,0.6,0.4l-7.8,0c0,0-3.7-1.9-8-5.1c-0.1,0-0.1-0.1-0.2-0.1 c-0.8-0.6-1.6-1.2-2.4-1.9c0,0-0.1-0.1-0.1-0.1c-2.3-1.9-4.6-4.2-6.5-6.7c-1.9-2.5-3.3-5.2-4-8.1c0.3,1.8,1.9,9.7,5.3,16.9 c0,0-9.9-12.2-14.4-18.1c-2.5-3.3-11.3-10.5-18.2-21.3l0-0.1c-1.3-2-2.5-4.1-3.5-6.3c-1.9-3.9-3.5-8.3-4.4-12.9 c0,0,14.9-25.9,24.6-46.7c4.1-8.8,7.1-18.5,10.7-27.5c0-0.1,0.1-0.2,0.1-0.3c0.1-0.2,0.2-0.4,0.3-0.7c0.4-1,0.8-2,1.2-2.9 c0.3-0.8,0.7-1.6,1.1-2.3c0.8-1.8,1.6-3.5,2.5-5.1c0.3-0.5,0.6-1.1,0.9-1.6c0.1-0.2,0.2-0.4,0.3-0.5c0,0,0-0.1,0-0.1c0,0,0,0,0,0 c0,0,0,0,0,0c0,0,0,0,0,0v0c0,0,0,0,0,0c3.8-6.5,8.5-11.9,15-15.3c10.2-5.4,19.6-6.2,28.1-5.5c0.3,0,0.6,0,0.9,0.1 c9.4,0.8,17.6,3.3,24.6,3.2c4.6-0.1,11.7-0.6,19.5-0.8c0,0,0,0,0,0c7.2-0.2,15-0.2,22.1,0.5c0.1,0,0.1,0,0.2,0 c7.8,0.8,14.8,2.5,18.9,5.7c3.3,2.6,6.2,5.8,8.8,9.6c0,0,0.1,0.1,0.1,0.1c2.7,3.9,5,8.4,7,13c0,0,0,0.1,0,0.1 c7.4,17,11.2,37,15.7,46.8C209.5,105.4,219.7,117.9,218.7,127.4z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M92,31.3c0,0.1-0.1,0.1-0.1,0.2c-1.3,1.7-2.5,4-3.6,6.6c0,0.1-0.1,0.1-0.1,0.2c-3.1,6.5-7,16.6-6.8,26.7 C73.4,45,91.1,32,92,31.3z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M35.2,153.8c1.9,12.4,6.3,19.5,10.6,23.5c-2.3-1.9-4.6-4.2-6.5-6.7c-1.4-2.5-2.8-5.3-4.1-8.5 c-8.7-21.9-5.8-36.9,3-66.9c8.8-30,0.6-48.1,10.7-65.3C57,15.9,77.3,12.7,84.8,12c1.8-0.2,2.9-0.2,2.9-0.2s-0.7,0.1-1.9,0.3 c-5.8,0.9-23.5,4.7-33.1,16.4C41,42.7,45.7,66,43.9,82.6C42.1,99.2,30.8,125.3,35.2,153.8z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M100.5,14.7c-1.5,0.5-25.3,8.4-34.9,21c-9.9,12.9-10.4,30.1-10.4,30.1s-3,29.1-7.1,50.2 c-4,20.8,6.1,60.6,15.7,68.1l-0.3,0.4l-6.9,0c0,0-3.7-1.9-8-5.1c4.5,3,8.3,3,8.3,3s-19.8-35.6-11.3-70c8.5-34.4,3-61.7,16.4-77 C74.8,20.6,99,15,100.5,14.7z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.9,139.9c0,0-6.4-12.9,12.7-37.6c19.1-24.6,14.1-60.2,21-69.5c0,0-3.9,6.9-6.3,13.3 c-2.4,6.4-2.4,29.7-11.1,46.5C15.6,109.5,5.9,114,4.4,133.5L7.9,139.9z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M118.7,14.9c0,0,33.9,7.3,45,33.4C163.8,48.3,156.1,18.2,118.7,14.9z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M129.8,14.5c0,0,35.3,4.3,44.5,35.7c9.2,31.5,8.8,56.7,17.3,77.2c8.5,20.5,1.1,31.6,1.1,31.6l4.8-5.4 c0,0,6.2-10.2-5-33c-11.2-22.8-9.3-60.8-18.1-77.2c-8.8-16.4-29.4-27.2-39.2-28.9L129.8,14.5z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M151.9,14.9c0,0,25.7,5.4,33.6,28.7c7.9,23.3,2.8,42.8,15,62.7s11.9,33.5,11.9,33.5l5.2-8.7 c0,0-2.4-4.4-16.9-26.7c-9.9-15.3-8.5-48.3-14.9-64.5C179.2,23.8,163,17.6,151.9,14.9z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M173,22.3c0,0,1.4,2.2,0,4.5c-1.4,2.3-12.3,7.5-12.8,10.9c-0.4,3.4-18.9,5.1-18.9,5.1v6.8c0,0,18,0.1,21-1.4 c3-1.5-0.4-9.6,2.2-12.2c2.6-2.6,10.7-3.3,12.2-4.3c1.5-0.9,1.6-3.6,1.6-3.6S174.9,23.9,173,22.3z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M137.1,43.2l-16.4-0.8l0,8c0,0,10.9-3.1,17,0L137.1,43.2z"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M99.2,39.9c0,0-1.8,4.9-1.8,9.6l-9.7,0.9c0,0,0.5-7.5,3-11.2L99.2,39.9z"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M84.5,39.2c0,0-7,0.8-12.6-1.8c-5.5-2.6-4.7-2.2-13.1-5.7c-8.4-3.5-3.8-10.3-2.1-14.1c0,0-4.8,2.3-8,6 c0,0,0.1,7,6.2,9.3c6.1,2.4,7.6,7.4,9.4,9.6c1.8,2.2,18.2,0,18.2,0L84.5,39.2z"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M193.3,122.6c0,0,3,3.6,5.6,17.3c0,0,2.2-8.3,5.6-10.1c3.5-1.7,5.6-3,5.6-3l-4.9-10c0,0,0.6,3.8-2.6,5.8 C197.1,125.8,193.3,122.6,193.3,122.6z"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M210.1,117.6c0,0,4.8-2.2,5.4-3.1l1.4,3.1l-3.4,4.9C213.4,122.6,212,119.3,210.1,117.6z"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M189.1,124.7l-7.7,1.1c0,0,1.3,7.7-3.1,21.1c0,0,10-6.4,16.9-6.9C195.2,139.9,191.9,129.4,189.1,124.7z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M43.6,124.7c0,0-0.7,15.4,1.9,25.7c0,0-9.3-7.9-10.3-7.8c0,0-0.1-9.9,0.9-17.9 C36.1,124.7,42,124.3,43.6,124.7z"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M31.6,120.6c0,0-13.6-6-15.4-12.1c0,0-3.6,4.9-5.5,9.9c0,0,13.3,8.4,19.1,18.1 C29.8,136.4,30.6,125.4,31.6,120.6z"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M15.3,106.2c0,0-4.5-2.9-5.2-3.9l-4.3,10.2l2.9,1.3C8.8,113.7,11.1,110.1,15.3,106.2z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHair4);
export default __webpack_public_path__ + "static/media/Hair4.8d205bad98bf73675ed599d6a31a370d.svg";
export { ForwardRef as ReactComponent };